import { useTranslation } from 'react-i18next';
import { AppSubBar } from '@up2d8/ui';
import { AppShortcuts } from './app-shortcuts';

/**
 * Alle tegels op een eigen scherm.
 *
 * Bestaat omdat het beginscherm er hoogstens acht toont (UI-2). Die grens is nodig — twaalf tegels
 * duwden de tijdlijn onder de vouw — maar een grens zonder uitweg verbergt tegels, en dat is erger
 * dan een lang rooster. Hier staan ze allemaal.
 *
 * Een subscherm met een terugpijl en geen tab: je komt hier vanaf het beginscherm en je gaat
 * daarna terug. Dezelfde vorm als de collega-lijst en de instellingen.
 */
export function AppShortcutsPage() {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-dvh flex-col bg-background">
      <AppSubBar title={t('shortcuts.heading')} onBack={() => window.history.back()} />
      <main className="flex-1 px-page-x py-page-y">
        <AppShortcuts homeOnly={false} />
      </main>
    </div>
  );
}
